import { render } from "./imageModal.vue?vue&type=template&id=50972c94&scoped=true"
import script from "./imageModal.vue?vue&type=script&lang=js"
export * from "./imageModal.vue?vue&type=script&lang=js"

import "./imageModal.vue?vue&type=style&index=0&id=50972c94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50972c94"

export default script